"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinPriceAndPreview = void 0;
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const react_1 = __importDefault(require("react"));
const NumericInput_1 = require("../../input/numeric/NumericInput");
const Paragraph_1 = require("../../paragraph/Paragraph");
const Spacer_1 = require("../../spacer/Spacer");
const price_graph_gbp_svg_1 = __importDefault(require("./price-graph_gbp.svg"));
const price_graph_usd_svg_1 = __importDefault(require("./price-graph_usd.svg"));
const price_graph_eur_svg_1 = __importDefault(require("./price-graph_eur.svg"));
const useExperiment_1 = require("../../../../hooks/useExperiment");
const pricing_1 = require("../../../../entities/pricing");
const helpers_1 = require("../../../pages/tasks/pricing/helpers");
const fullStory_1 = require("../../../../util/fullStory");
const index_1 = require("../../../../index");
const getCurrencyBasedSvg = (currency) => {
    switch (currency) {
        case 'GBP':
            return price_graph_gbp_svg_1.default;
        case 'EUR':
            return price_graph_eur_svg_1.default;
        case 'USD':
            return price_graph_usd_svg_1.default;
        default:
            return price_graph_gbp_svg_1.default;
    }
};
const getPricingUpdateFrequencyString = (customerId) => {
    const customerExperiments = (0, useExperiment_1.useCustomerExperiments)(customerId);
    switch (customerExperiments === null || customerExperiments === void 0 ? void 0 : customerExperiments.smart_pricing_customer) {
        case pricing_1.SMART_RATE.daily:
            return 'every 24 hours';
        case pricing_1.SMART_RATE.every_2_days:
            return 'every 48 hours';
        default:
            // this shouldn't happen but covers an error case
            return 'regularly';
    }
};
const MinPriceAndPreview = ({ defaults, setDefaults, validation, showValidation, setShowValidation }) => {
    var _a;
    const { propertyId, customerId } = react_1.default.useContext(index_1.AppContext);
    react_1.default.useEffect(() => {
        (0, fullStory_1.sendCustomFullStoryEvent)('smart_pricing_min_price_modal_viewed', { property_id: propertyId });
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(NumericInput_1.NumericInput, { label: "Minimum nightly price", id: "min-price-input", value: (0, helpers_1.fromFloyd)(defaults.min_price), handleChange: (value) => {
                setShowValidation(true);
                setDefaults(Object.assign(Object.assign({}, defaults), { min_price: (0, helpers_1.toFloyd)(value !== null && value !== void 0 ? value : 0) }));
            }, valid: showValidation ? ((_a = validation === null || validation === void 0 ? void 0 : validation.min_price) !== null && _a !== void 0 ? _a : true) : true, 
            // If not true
            errorMessage: 'The minimum price per night must be greater than 0.' }),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
        react_1.default.createElement(merlin_info_panels_1.DidYouKnow, { id: "min-price-info-panel", icon: getCurrencyBasedSvg(defaults.currency), colour: { background: '#f7f7f7', text: '#666666' }, text: "Set a limit that your prices can never go below, even when demand is low." }),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "large" }),
        react_1.default.createElement(Paragraph_1.Paragraph, null,
            "Smart pricing generates a year of pricing and updates ",
            getPricingUpdateFrequencyString(customerId),
            " to keep up with changing demand. Review your prices before continuing.")));
};
exports.MinPriceAndPreview = MinPriceAndPreview;
//# sourceMappingURL=MinPriceAndPreview.js.map